export default __webpack_public_path__ + "static/media/delete.a1344296.svg";